import { render, staticRenderFns } from "./CustomerMgmt.vue?vue&type=template&id=03eb1276"
import script from "./CustomerMgmt.vue?vue&type=script&lang=js"
export * from "./CustomerMgmt.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports